module.exports = __webpack_public_path__ + "static/media/fiona_and_allison.b0989bc4.jpg";